<div class="qs-page">
  <div class="qs-shell">
    <header class="qs-header">
      <div class="qs-brand">
        <img src="assets/allbrainbaby.png" class="qs-logo" alt="Quack Studio logo" />&nbsp;&nbsp;

        <div class="qs-titleblock">
          <h1 class="ss-tar-heels">
            <span class="genius-vision">CopyVision</span>
            <span class="middle-text"> Is Tuned -> Trained -> Tested -> For </span>
            <span class="inventiveness">Inventiveness</span>
          </h1>

          <p class="qs-subtitle">
            1. Choose your <span class="pink-balls">Description Length</span>
            <i class="fas fa-chevron-down pink-balls"></i>
          </p>

          <p class="qs-subtitle">
            2. Attach an image via the
            <img
              src="assets/icons/utilities/image.svg"
              height="20"
              class="pink-balls"
              alt="Upload icon"
            />
            &nbsp;<span class="pink-balls">Upload Image</span> button.
          </p>

          <p class="qs-subtitle">
            3. Click
            <mat-icon class="ss-butt-icon" svgIcon="upload" aria-hidden="true"></mat-icon>
            &nbsp;<span class="ss-butt-icon ieatkim">Generate</span>
            for your CopyVision result.
          </p>
        </div>

        <img src="assets/allbrainbaby.png" class="qs-go" alt="Quack Studio logo" />
      </div>

      <div class="qs-header-actions"></div>
    </header>

    <section class="qs-controls">
      <div class="qs-card">
        <label class="qs-label pink-balls">Image</label>

        <label class="qs-upload" for="duckFile">
          <input
            id="duckFile"
            type="file"
            (change)="onFileSelected($event)"
            accept=".jpg,.jpeg,.png"
            hidden
          />

          <span class="qs-upload-icon">
            <i class="fas fa-image" aria-hidden="true"></i>
          </span>

          <span class="qs-upload-text">
            <strong class="attachImage">Upload Image</strong>
            <small class="image-types" *ngIf="!selectedFile">JPG, JPEG, PNG</small>
            <small *ngIf="selectedFile">{{ selectedFile.name }}</small>
          </span>
        </label>
      </div>

      <div class="qs-card">
        <label class="qs-label">Description Length</label>

        <div class="qs-dropdown">
          <button type="button" class="qs-dropdown-trigger" (click)="toggleDropdown('desc')">
            <span>{{ selectedDescLabel }}</span>
            <i class="fa fa-chevron-down qs-dropdown-arrow"></i>
          </button>

          <div class="qs-dropdown-menu" *ngIf="dropdownOpen === 'desc'">
            <button
              type="button"
              class="qs-dropdown-item"
              *ngFor="let opt of descriptionOptions; trackBy: trackByValue"
              [class.active]="selectedDescriptionType === opt.value"
              (click)="selectDescType(opt.value)"
            >
              {{ opt.label }}
            </button>
          </div>
        </div>
      </div>

      <div class="qs-card qs-card-generate">
        <label class="qs-label pink-balls">Generate</label>

        <button
          (click)="onUpload()"
          [disabled]="!selectedFile || isLoading"
          class="qs-btn qs-btn-primary"
          type="button"
        >
          <mat-icon class="qs-btn-icon" svgIcon="upload" aria-hidden="true"></mat-icon>
          {{ isLoading ? 'Generating...' : 'Generate' }}
        </button>
      </div>
    </section>

    <button class="x-share-btn" (click)="shareToX()">
      <span class="x-icon">𝕏</span>
      <span class="x-text">Share on X</span>
    </button>

    <div *ngIf="isLoading" class="qs-loading">
      <span class="qs-spinner"></span>
      <span>{{ loadingText }}</span>
    </div>

    <section class="qs-results" *ngIf="uploadedImages.length > 0">
      <h2 class="qs-results-title">Result</h2>

      <div class="qs-grid">
        <article *ngFor="let img of uploadedImages; let i = index" class="qs-result-card">
          <div class="qs-image" *ngIf="img.url">
            <img [src]="img.url" alt="Generated image result {{ i + 1 }}" />
          </div>

          <div class="qs-caption">
            <div class="qs-caption-header">
              <span class="qs-caption-index">#{{ i + 1 }}</span>

              <div class="qs-caption-actions">
                <button
                  class="qs-icon-btn"
                  (click)="openEditDialog(img)"
                  type="button"
                  aria-label="Edit description"
                >
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>

                <button
                  class="qs-icon-btn"
                  (click)="shareImage(img.url, img.description)"
                  type="button"
                  aria-label="Share on Facebook"
                >
                  <i class="fa fa-share-alt" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <p class="qs-caption-text">{{ img.description }}</p>
          </div>
        </article>
      </div>
    </section>

    <div *ngIf="errorMessage" class="qs-error" role="alert">
      {{ errorMessage }}
    </div>
  </div>
</div>